import { render, staticRenderFns } from "./Recap.vue?vue&type=template&id=3a8a6157"
import script from "./Recap.vue?vue&type=script&lang=js"
export * from "./Recap.vue?vue&type=script&lang=js"
import style0 from "./Recap.vue?vue&type=style&index=0&id=3a8a6157&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports